import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "azg",
  style: {"background-color":"#eef4fc"}
}

import {
  AlzguardTitle,
  AlzguardIntroductionCard,
  AlzguardExamples,
} from "../../components/alzguard";
import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_spacer, {
      class: _normalizeClass({ 'py-3': _unref(xs), 'py-6': _unref(smAndUp) })
    }, null, 8, ["class"]),
    _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "elevation-0",
          style: {"background-color":"transparent"}
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(AlzguardTitle)),
            _createVNode(_unref(AlzguardIntroductionCard)),
            _createVNode(_unref(AlzguardExamples))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_spacer, {
      class: _normalizeClass({ 'py-5': _unref(xs), 'py-6': _unref(smAndUp) })
    }, null, 8, ["class"])
  ]))
}
}

})